module.exports = __webpack_public_path__ + "media/bootstrap-icons/record2-a3ef5b62.svg";